module.exports = __webpack_public_path__ + "static/media/Incorrect inclination of the tooth13.0e2be0c1.png";